var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.languages.length > 1
    ? _c(
        "div",
        {
          staticClass: "i18n_group",
        },
        [
          _vm.selectedLanguage !== null
            ? _c(
                "div",
                {
                  staticClass: "i18n",
                  attrs: {
                    "data-lang": _vm.selectedLanguage.name,
                    "data-icon":
                      "url(" +
                      _vm.assetsURL +
                      "images/languages/" +
                      _vm.selectedLanguage.picture +
                      ")",
                  },
                },
                [
                  _vm.type === "text"
                    ? _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentText,
                                  expression: "currentText",
                                },
                              ],
                              ref: "inputfield",
                              attrs: {
                                type: "text",
                                name: _vm.nameOfInput(_vm.selectedLanguage.id),
                                required:
                                  _vm.required &&
                                  _vm.defaultLanguage ===
                                    _vm.selectedLanguage.id,
                              },
                              domProps: {
                                value: _vm.currentText,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentText = $event.target.value
                                },
                              },
                            },
                            "input",
                            _vm.$attrs,
                            false
                          ),
                          _vm.$listeners
                        )
                      )
                    : _vm.type === "textarea"
                    ? _c(
                        "textarea",
                        _vm._g(
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentText,
                                  expression: "currentText",
                                },
                              ],
                              ref: "inputfield",
                              attrs: {
                                name: _vm.nameOfInput(_vm.selectedLanguage.id),
                                required:
                                  _vm.required &&
                                  _vm.defaultLanguage ===
                                    _vm.selectedLanguage.id,
                              },
                              domProps: {
                                value: _vm.currentText,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.currentText = $event.target.value
                                },
                              },
                            },
                            "textarea",
                            _vm.$attrs,
                            false
                          ),
                          _vm.$listeners
                        )
                      )
                    : _c(
                        "studip-wysiwyg",
                        _vm._g(
                          _vm._b(
                            {
                              ref: "inputfield",
                              attrs: {
                                name: _vm.nameOfInput(_vm.selectedLanguage.id),
                                required:
                                  _vm.required &&
                                  _vm.defaultLanguage ===
                                    _vm.selectedLanguage.id,
                              },
                              model: {
                                value: _vm.currentText,
                                callback: function callback($$v) {
                                  _vm.currentText = $$v
                                },
                                expression: "currentText",
                              },
                            },
                            "studip-wysiwyg",
                            _vm.$attrs,
                            false
                          ),
                          _vm.$listeners
                        )
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.otherLanguages, function (language) {
            return _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentText,
                  expression: "currentText",
                },
              ],
              key: "hidden-".concat(language.id),
              attrs: {
                type: "hidden",
                required: _vm.required && _vm.defaultLanguage === language.id,
                name: _vm.nameOfInput(language.id),
              },
              domProps: {
                value: _vm.currentText,
              },
              on: {
                input: function input($event) {
                  if ($event.target.composing) return
                  _vm.currentText = $event.target.value
                },
              },
            })
          }),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "i18n",
              style:
                "background-image: url(" +
                _vm.assetsURL +
                "images/languages/" +
                _vm.selectedLanguage.picture +
                ")",
              attrs: {
                tabindex: "0",
                "aria-label": _vm.$gettext("Sprache des Textfeldes auswählen."),
              },
              on: {
                change: _vm.selectLanguage,
              },
            },
            _vm._l(_vm.languages, function (language) {
              return _c(
                "option",
                {
                  key: "option-".concat(language.id),
                  domProps: {
                    value: language.id,
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(language.name) + "\n        "
                  ),
                ]
              )
            }),
            0
          ),
        ],
        2
      )
    : _c(
        "div",
        [
          _vm.type === "text"
            ? _c(
                "input",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentText,
                          expression: "currentText",
                        },
                      ],
                      ref: "inputfield",
                      attrs: {
                        type: "text",
                        name: _vm.name,
                        required: _vm.required,
                      },
                      domProps: {
                        value: _vm.currentText,
                      },
                      on: {
                        input: function input($event) {
                          if ($event.target.composing) return
                          _vm.currentText = $event.target.value
                        },
                      },
                    },
                    "input",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "textarea"
            ? _c(
                "textarea",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.currentText,
                          expression: "currentText",
                        },
                      ],
                      ref: "inputfield",
                      attrs: {
                        name: _vm.name,
                        required: _vm.required,
                      },
                      domProps: {
                        value: _vm.currentText,
                      },
                      on: {
                        input: function input($event) {
                          if ($event.target.composing) return
                          _vm.currentText = $event.target.value
                        },
                      },
                    },
                    "textarea",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _c(
                "studip-wysiwyg",
                _vm._g(
                  _vm._b(
                    {
                      ref: "inputfield",
                      attrs: {
                        name: _vm.name,
                        required: _vm.required,
                      },
                      model: {
                        value: _vm.currentText,
                        callback: function callback($$v) {
                          _vm.currentText = $$v
                        },
                        expression: "currentText",
                      },
                    },
                    "studip-wysiwyg",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }